import { Routes } from '@angular/router';

// Replaces dev.routes.ts in production and staging builds (angular.json).
export const devRoutes: Routes = [];
